import React from 'react';
import { Modal, ModalProps, Typography, Col, Space } from 'antd';
import moment from 'moment';
import { ButtonGoBack, CustomFooterContainer } from './styles';
import { WHATSAPP_SUPORT } from '../../../helpers/constants';
import { ParserLink } from '../../../utils/parserLink';

interface Props extends ModalProps {
    title: string;
    label?: string;
    info: { reason: string; date: string } | undefined;
}

export const AcessBlockedUserModal = ({
    title,
    label,
    onCancel,
    open,
    info,
}: Props) => {
    const { Text, Title } = Typography;

    return (
        <>
            <Modal
                bodyStyle={{
                    padding: '20px 24px',
                }}
                style={{ minWidth: '15vw' }}
                onCancel={onCancel}
                title={
                    <Title
                        level={4}
                        style={{ marginBottom: 0, textAlign: 'center' }}
                    >
                        {title}
                    </Title>
                }
                open={open}
                closable={false}
                footer={null}
            >
                {label && <Text>{label}</Text>}

                <Space
                    direction="vertical"
                    align="center"
                    style={{ width: '100%', marginBottom: 12 }}
                >
                    <Col style={{ width: '100%', textAlign: 'center' }}>
                        <Title level={5} style={{ marginBottom: 0 }}>
                            Data do bloqueio:
                        </Title>
                        {moment(info?.date).format('DD / MM / YYYY')}
                    </Col>
                    <Col style={{ width: '100%', textAlign: 'center' }}>
                        <Title level={5} style={{ marginBottom: 0 }}>
                            Motivo:
                        </Title>
                        <Text>{info?.reason && ParserLink(info?.reason)}</Text>
                    </Col>
                </Space>

                <CustomFooterContainer>
                    <ButtonGoBack onClick={onCancel} style={{ width: '100%' }}>
                        Fechar
                    </ButtonGoBack>
                    <ButtonGoBack style={{ width: '100%' }}>
                        <a
                            href={WHATSAPP_SUPORT}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Falar com suporte
                        </a>
                    </ButtonGoBack>
                </CustomFooterContainer>
            </Modal>
        </>
    );
};
